namespace TabAurous.OMS {
    export interface DocumentFormatMasterRow {
        SuffixprefixId?: number;
        VoucherTypeId?: string;
        VoucherTypeName?: string;
        MaterialType?: string;
        StartIndex?: number;
        Separator?: string;
        Prefix?: string;
        PrefixDate?: string;
        Suffix?: string;
        Format?: string;
        IncrementBy?: number;
        LastNumber?: number;
        PrefillwithZero?: boolean;
        Noofzeroes?: number;
        BranchWise?: boolean;
        CounterWise?: boolean;
        Lock?: boolean;
        ResetMonthly?: boolean;
        ResetYearly?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace DocumentFormatMasterRow {
        export const idProperty = 'SuffixprefixId';
        export const nameProperty = 'VoucherTypeId';
        export const localTextPrefix = 'OMS.DocumentFormatMaster';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SuffixprefixId = "SuffixprefixId",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            MaterialType = "MaterialType",
            StartIndex = "StartIndex",
            Separator = "Separator",
            Prefix = "Prefix",
            PrefixDate = "PrefixDate",
            Suffix = "Suffix",
            Format = "Format",
            IncrementBy = "IncrementBy",
            LastNumber = "LastNumber",
            PrefillwithZero = "PrefillwithZero",
            Noofzeroes = "Noofzeroes",
            BranchWise = "BranchWise",
            CounterWise = "CounterWise",
            Lock = "Lock",
            ResetMonthly = "ResetMonthly",
            ResetYearly = "ResetYearly",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
